/**
 * Przyciski „Kopiuj” w sekcji Kontakt: kopiują numer lub e-mail do schowka.
 */

/** Jak długo przycisk pokazuje „Skopiowano”. */
export const COPIED_MS = 2000;

/**
 * Kopiuje tekst do schowka; gdy Clipboard API jest niedostępne (np. strona
 * bez HTTPS), używa ukrytego pola tekstowego i execCommand("copy").
 * @param {string} text
 * @param {{clipboard?: {writeText: (t: string) => Promise<void>}}} [nav]
 * @param {Document} [doc]
 * @returns {Promise<boolean>} czy kopiowanie się udało
 */
export async function copyText(text, nav = globalThis.navigator, doc = globalThis.document) {
  try {
    if (nav?.clipboard?.writeText) {
      await nav.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Spróbuj sposobu zapasowego poniżej.
  }
  if (!doc) return false;
  const field = doc.createElement("textarea");
  field.value = text;
  field.setAttribute("readonly", "");
  field.style.position = "fixed";
  field.style.opacity = "0";
  doc.body.appendChild(field);
  field.select();
  let ok = false;
  try {
    ok = doc.execCommand("copy");
  } catch {
    ok = false;
  }
  field.remove();
  return ok;
}

export function initCopyButtons() {
  document.querySelectorAll(".copy-btn[data-copy]").forEach((button) => {
    const label = button.querySelector(".copy-label");
    let timer;
    button.addEventListener("click", async () => {
      const ok = await copyText(button.dataset.copy);
      label.textContent = ok ? "Skopiowano" : "Nie udało się";
      button.classList.toggle("is-copied", ok);
      clearTimeout(timer);
      timer = setTimeout(() => {
        label.textContent = "Kopiuj";
        button.classList.remove("is-copied");
      }, COPIED_MS);
    });
  });
}
